<form (ngSubmit)="submit()">
	<ng-content></ng-content>
</form>
